export enum SelectedArea{
    Europe,
    France,
    Departments
  }